"use strict";

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReportLiveReportPreview = void 0;

var reportinglivepreviewApi_1 = require("./reportinglivepreviewApi");

var pwc_deals_web_common_1 = require("@pwc/pwc-deals-web-common");

var axios_1 = __importDefault(require("axios"));

var Constants_1 = __importDefault(require("../Constants"));

var userTokenService_1 = __importDefault(require("./userTokenService")); // @ts-ignore


var axiosInstance = axios_1.default.create({});
axiosInstance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.resolve(error);
}); // TODO: fix once we update the helm chars

var baseApiEndpoint = process.env && process.env.REACT_APP_REPORTING_LIVE_PREVIEW_SERVICE ? process.env.REACT_APP_REPORTING_LIVE_PREVIEW_SERVICE.replace('/reportlivepreviewapi', '') : Constants_1.default.BASE_API_END_POINT;

var httpClient = function (projectId) {
  return new pwc_deals_web_common_1.HttpClient(baseApiEndpoint, function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , userTokenService_1.default.getCurrentProjectToken(projectId)];
      });
    });
  }, axiosInstance);
}; // @ts-ignore


var ReportingHttpClient =
/** @class */
function (_super) {
  __extends(ReportingHttpClient, _super);

  function ReportingHttpClient(projectId) {
    var _this = _super.call(this) || this; // @ts-ignore


    _this.instance = httpClient(projectId); // @ts-ignore

    _this.mergeRequestParams = _this.mergeRequestParams2;
    return _this;
  }

  ReportingHttpClient.prototype.mergeRequestParams2 = function (params1, params2) {
    return __assign(__assign(__assign(__assign({}, this.instance.defaults), params1), params2 || {}), {
      // @ts-ignore
      headers: __assign(__assign(__assign({}, this.instance.defaults && this.instance.defaults.headers || {}), params1.headers || {}), params2 && params2.headers || {})
    });
  };

  return ReportingHttpClient;
}(reportinglivepreviewApi_1.HttpClient);

var reportingLivePreviewApi = function (projectId) {
  return new reportinglivepreviewApi_1.ReportingLivePreviewApi(new ReportingHttpClient(projectId));
};

var getReportLiveReportPreview = function (projectId, reportData, type) {
  return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , reportingLivePreviewApi(projectId // @ts-ignore
          ).reportlivepreviewapi.previewLiveReport(projectId, reportData, type)];

        case 1:
          data = _a.sent().data; // @ts-ignore

          return [2
          /*return*/
          , data.data];
      }
    });
  });
};

exports.getReportLiveReportPreview = getReportLiveReportPreview;